<template>
  <div class="head-container">
    <div v-if="$store.state.app.device == 'desktop'">
      <el-row type="flex" justify="space-between" style="margin: 0 50px">
        <el-col :span="3">
          <img src="../assets/images/logo.png" class="logo" @click="$router.push({ path: '/' })" />
        </el-col>
        <el-col :span="17">
          <el-row>
            <el-col :md="3" :xl="2" v-for="(item, index) in menuList" :key="index">
              <div @click="handleMenuClick(item, index)" @mouseenter="handleMenuEnter(item, index)"
                @mouseleave="handleMenuLeave(item)">
                <span class="text" :style="{ color: curIndex == index ? '#D7000F' : '#bdc3c7', fontSize: '16px' }">{{
                  item.name
                }}</span>
                <i class="el-icon-arrow-down" v-if="item.isDropdown && curIndex !== index"
                  :style="{ color: curIndex == index ? '#D7000F' : '#bdc3c7', 'font-size': '10px' }"></i>
                <i class="el-icon-arrow-up" v-else-if="item.isDropdown && curIndex == index"
                  :style="{ color: curIndex == index ? '#D7000F' : '#bdc3c7', 'font-size': '10px' }"></i>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="5">
          <div style="float: right">
            <div v-if="userName" style="display: flex;line-height: 64px; height: 64px;">
              <div class="searchbox" :class="minisearch ? 'minisearch' : ''" v-if="showSearch">
                <div class="searchs">
                  <el-input placeholder="请输入搜索内容" v-model="search" class="search"
                    style="height: 40px;width: 384px;background-color: #555 !important; margin-right: 6px;"
                    @keyup.enter.native="inputSearch">
                    <el-button slot="append" icon="el-icon-search" @click="inputSearch"></el-button>
                  </el-input>
                  <span style="line-height: 40px; cursor: pointer;" @click="() => {
                    search = ''
                    showSearch = false
                  }">
                    <img src="../assets/images/close.png" alt="">
                  </span>
                </div>
                <div class="hotpot">
                  <p class="title">
                    热点搜索
                  </p>
                  <div class="potbox">
                    <ul>
                      <li v-for="(item, index) in hotpotlist" :key="index" @click="gosearch(item)">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <span v-show="!showSearch" style="color: #fff;cursor: pointer"
                @click="showSearch = true, largesearch = true, search = ''"><i class="el-icon-search"
                  style="font-size: 18px"></i></span>

              <div style="display: flex;align-items: center; width: 200px;">
                <el-divider direction="vertical"></el-divider>
                <span class="console" @click="handleCommand('console')">工作台</span>
                <div style="width: 110px;">
                  <el-dropdown @command="handleCommand">
                    <span style="color: #fff;cursor: pointer;">
                      <i class="el-icon-user-solid" style="font-size: 14px"></i>
                      <span style="font-size: 14px">{{ usernameInit(userName) }}</span>
                      <i class="el-icon-arrow-down el-icon--right" style="font-size: 14px"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item command="info" icon="el-icon-user">个人信息</el-dropdown-item>
                      <el-dropdown-item command="resetPhone" icon="el-icon-document-checked">修改绑定手机</el-dropdown-item>
                      <el-dropdown-item command="reset" icon="el-icon-lock">修改密码</el-dropdown-item>
                      <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div v-else style="display: flex;line-height: 64px; height: 64px;">
              <div class="searchbox" :class="minisearch ? 'minisearch' : ''" v-if="showSearch">
                <div class="searchs">
                  <el-input placeholder="请输入搜索内容" v-model="search" class="search"
                    style="height: 40px;width: 384px;background-color: #555 !important; margin-right: 6px;"
                    @keyup.enter.native="inputSearch">
                    <el-button slot="append" icon="el-icon-search" @click="inputSearch"></el-button>
                  </el-input>
                  <span style="line-height: 40px; cursor: pointer;" @click="() => {
                    search = ''
                    showSearch = false
                  }">
                    <img src="../assets/images/close.png" alt="">
                  </span>
                </div>
                <div class="hotpot">
                  <p class="title">
                    热点搜索
                  </p>
                  <div class="potbox">
                    <ul>
                      <li v-for="(item, index) in hotpotlist" :key="index" @click="gosearch(item)">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>


              </div>
              <span v-show="!showSearch" style="color: #fff;cursor: pointer"
                @click="showSearch = true, largesearch = true, search = ''"><i class="el-icon-search"
                  style="font-size: 18px"></i></span>
              <div style=" display: flex;align-items: center; width: 200px;">
                <el-divider direction="vertical"></el-divider>
                <router-link to="/login">
                  <span class="text login">登录</span>
                </router-link>
                <router-link to="/register">
                  <div class="text register">免费注册</div>
                </router-link>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="position: relative;" v-if="$store.state.app.device == 'desktop'">
      <transition name="el-zoom-in-top">
        <div class="drawer" v-if="visible" @mouseleave="handleDrawerLeaver">
          <div v-if="visible && searchShow" class="serchBox">
            <el-autocomplete class="inline-input" v-model="searchVal" :fetch-suggestions="querySearch" placeholder="搜索产品"
              :trigger-on-focus="false" :popper-append-to-body="false" @select="handleSelectTwo">
              <i class="el-icon-search" slot="suffix"></i>
              <template #default="{ item }">
                <div class="autocomplete-item">
                  <div class="autocomplete-item__value">{{ item.value }}</div>
                  <div class="autocomplete-item__desc">{{ item.content }}</div>
                </div>
              </template>
            </el-autocomplete>
          </div>
          <div class="drawer-left" :style="{ top: searchShow ? '58px' : '0px' }">
            <div v-for="(item, index) in list" :key="index" class="classification"
              :style="{ color: index ? '' : '#E50009' }" @click="handleClassClick(item, index)">
              <div :class="{ active: active == index }">
                <img :src="item.columnIcon" width="14px" height="14px" alt="" v-if="item.columnIcon"
                  style="margin-bottom: -2px;" />
                <i :class="item.iconLeft"></i>
                <span>{{ item.columnName }}</span>
                <i :class="item.iconRight"></i>
              </div>
            </div>
          </div>
          <div class="drawer-right" v-if="list[active]" :style="{ top: searchShow ? '50px' : '0px' }">
            <div v-for="(item, index) in list[active].childrenList" :key="index" class="details"
              @click="handleDetailsClick(item, index)">
              <div>{{ item.name }}</div>
              <span>{{ item.content }}</span>
            </div>
          </div>
          <div>
            <i class="el-icon-close drawer-close" @click="visible = false"></i>
          </div>
        </div>
      </transition>
      <div class="mask" v-if="visible"></div>
    </div>

    <div v-else>
      <el-row type="flex" justify="space-around" align="center">
        <el-col :span="4">
          <i class="el-icon-s-unfold" style="color: #ccc;font-size: 28px" @click="drawer = true"></i>
        </el-col>
        <el-col :span="16">
          <div v-if="userName" style="text-align: right;color: #ccc;">
            <i class="el-icon-user-solid" style="font-size:16px"></i>
            <span style="font-size: 16px">{{ userName }}</span>
          </div>
          <div v-else>
            <router-link to="/login">
              <span style="float: right;font-size: 16px;color: #ccc">登录</span>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-drawer :show-close="false" :modal="false" :visible.sync="drawer" :withHeader="false" direction="ltr">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-menu :default-active="`${curIndex}`" mode="horizontal" active-text-color="#e74c3c" @select="handleSelect">
              <el-menu-item :index="`${index}`" v-for="(item, index) in menuList" :key="index">{{ item.name }}
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-drawer>
    </div>
<!--
    <div class="suspend-box">
      <el-popover placement="left" width="248" trigger="hover">
        <el-row>
          <div class="popover-item">
            <el-col :span="5">
              <img src="@/assets/images/icon_footer_online.png" />
            </el-col>
            <el-col :span="19">
              <div @click="handleGoConsult">
                <div class="h1">在线咨询</div>
                <div class="h2">在线客服一对一沟通!</div>
              </div>
            </el-col>
          </div>

        </el-row>
        <el-row>
          <div class="popover-item">
            <el-col :span="5">
              <img src="@/assets/images/icon_footer_message.png" />
            </el-col>
            <el-col :span="19">
              <div @click="handleGoMessage">
                <div class="h1">线上留言</div>
                <div class="h2">点击去留言!</div>
              </div>
            </el-col>
          </div>

        </el-row>
        <el-row>
          <div class="popover-item">
            <el-col :span="5">
              <img src="@/assets/images/icon_footer_phone.png" />
            </el-col>
            <el-col :span="19">
              <div class="h1">联系电话</div>
              <div class="h2">0532-80995007</div>
              <div class="h3">魏经理/15621030087</div>
            </el-col>
          </div>
        </el-row>
        <div class="contact-btn" slot="reference">
          <span>联系我们</span>
          <i class="el-icon-chat-dot-square"></i>
        </div>
      </el-popover>

      <div style="width: 46px;text-align: center">
        <el-button icon="el-icon-arrow-up" circle size="medium" @click="handleGoTop"></el-button>
      </div>
      <consult v-if="open" title="在线留言" :dialogVisible="open" @cancel="cancle" productName="" productId="0"></consult>
    </div>-->

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import eventBus from '../utils/eventBus'
import fish from '@/utils/fishkefu.js'
import { columnList, listProduct, detailCoBuilding, detailPromotion } from '@/api'
import { getUserInfo, getveriftToken } from '@/api/console'

export default {
  name: 'Header',
  data() {
    return {
      open: false,
      // 手机模式菜单栏
      drawer: false,
      // 下拉导航
      visible: false,
      curIndex: 0,
      lastIndex: 0,
      active: 1,
      menuList: [],
      list: [],
      search: "",
      showSearch: false,
      minisearch: true,
      partnerList: [],
      listProduct: [],
      hotpotlist: ['一网统管', '垃圾分类', '集团管控', '收运系统'],
      menuSearchList: [
        {
          value: '选项1',
          label: '选项1'
        }
      ],
      searchVal: '',
      restaurants: [],
      searchShow: false,
      menuHeader: [],
    }
  },
  computed: {
    ...mapGetters([
      'userName',
    ]),

  },
  watch: {
    userName(newVal) {
      if (newVal) this.getProProduct()
    },
    $route(to, from) {
      this.drawer = false
      this.visible = false
      this.getCurIndex(to)
    },
    curIndex(newVal) {
      if (this.menuList[newVal].desc === 'ecoPartner') this.list[1] = this.partnerList
    }
  },
  beforeMount() {
    // console.log(object);
    fish.init()
  },
  created() {
    this.getColumn()
    if (this.userName) {
      this.getToken()
    }
  },
  mounted() {
    fish.config()
    eventBus.$on("closeSearch", (msg) => {
      // this.message = msg;
      // console.log(msg,'msgggg');
      if (msg) {
        this.search = ''
        this.showSearch = false
      }
    })
  },

  methods: {
    getProProduct() {
      getUserInfo().then(res => {
        this.listProduct = res.data.pList.map(item => {
          const arr = String(item.remark).split('@@')
          item.url = arr[0]
          item.desc = arr[1]
          return item
        })
      })
    },
    usernameInit(name) {
      if (name.length > 5) {
        return name.substring(0, 4) + '...'
      } else {
        return name
      }
    },
    // 获取生态伙伴数据
    async getPartnerList() {
      const list = [{
        name: "生态伙伴",
        path: "/EcoPartner",
        content: "指导单位，共建单位介绍，以及共建历程及原则。",
        homepageDisplay: '1'
      },]
      const res1 = detailCoBuilding().then((res) => {
        list.push({
          name: res.data.principleTitle,
          path: "/EcosystemJoint?name=coBuilding",
          content: res.data.principleContent,
          homepageDisplay: '1'
        })
      })
      const res2 = detailPromotion().then((res) => {
        list.push({
          name: res.data.principleTitle,
          path: "/EcosystemJoint?name=promotion",
          content: res.data.principleContent,
          homepageDisplay: '1'
        })
      })
      const data = await Promise.all([res1, res2])


      // data.forEach(v => {
      //   if()
      //   list.push({ name: v.data.principleTitle, path: "/EcosystemJoint", content: v.data.principleContent })
      // })

      this.partnerList = { childrenList: list }
    },
    //查询当前登录token是否有效
    async getToken() {
      const data = await getveriftToken();
      if (data.msg == 0) {
        console.log('token失效,清登录信息');
        this.quit();
      }
    },
    gosearch(item) {
      this.$router.push({
        path: '/search',
        query: {
          searchcontent: item
        }
      }),
        this.showSearch = false
    },
    //搜索
    inputSearch() {

      this.$router.push({
        path: '/search',
        query: {
          searchcontent: this.search
        }
      })
      this.showSearch = false;

      // this.minisearch = true;
      // const that = this
      // setTimeout(() => {
      // that.minisearch = true;
      // console.log(that,'that');
      // }, 300)
    },

    // 获取项目数据
    async getItem(id, key) {
      const res = await listProduct({ id })
      this.menuList[key[0]].children[key[1]].children = res.rows
    },
    // 获取菜单数据
    async getColumn() {
      const res = await columnList({ useFlag: '1' })
      const data = res.rows
      this.menuHeader = res.rows
      this.restaurants = this.loadAll(res.rows[1].children);

      // 生成导航配置
      const menuList = []
      /**
       *映射规则 --  home: '首页', productService: '产品服务', solution: '解决方案', ecoPartner: '生态伙伴', appMarket: '应用市场', information: '平台资讯', aboutUs: '关于平台'
       */
      data.forEach((v, i) => {
        switch (v.desc) {
          case 'home':
            menuList.push({ ...v, name: '首 页', path: '/', isDropdown: false })
            break;
          case 'productService': {
            const children = this.handleProductList(v.children) // 处理子列表数据
            menuList.push({ ...v, name: '产品服务', path: '/ProductService', isDropdown: true, children })
          }
            break;
          case 'solution': {
            const children = this.handleSolution(v.children) // 处理子列表数据
            menuList.push({ ...v, name: '解决方案', path: '/Solution', isDropdown: true, children })
          }
            break;
          case 'ecoPartner': {
            const children = this.handleEcoPartner(v.children) // 处理子列表数据
            menuList.push({ ...v, name: '生态伙伴', path: '/EcoPartner', isDropdown: true, children })
          }
            break;
          case 'appMarket':
            menuList.push({ ...v, name: '应用市场', path: '', isDropdown: false })
            break;
          case 'information':
            menuList.push({ ...v, name: '平台资讯', path: '/Information', isDropdown: false })
            break;
          case 'aboutUs':
            menuList.push({ ...v, name: '关于平台', path: '/AboutUs', isDropdown: false })
            break;
          case 'openPlatform':
            menuList.push({ ...v, name: '开放平台', path: '', isDropdown: false })
            break;
        }
      })
      this.menuList = menuList
      this.getCurIndex(this.$route)
    },

    // 处理产品服务自定义子项
    handleProductList(data) {
      // 添加默认item
      if (data.length) {
        const index = data.findIndex(v => v.desc === 'environmentalSanitation') //环卫产品
        if (index !== -1) data[index].childrenList.push({
          name: '天人厌氧子平台',
          path: '/AnSubPlatform?id=0',
          content: '项目设计-设备采购-财务税收-项目施工-原料收运-生产管控'
        })
      }

      const productList = [{
        columnName: '全部产品',
        iconLeft: 'el-icon-menu',
        iconRight: 'el-icon-arrow-right',
        path: '/ProductService'
      }, ...data]
      return productList
    },
    // 处理解决方案自定义子项
    handleSolution(data) {
      const solution = [{
        columnName: '全部方案',
        iconLeft: 'el-icon-menu',
        iconRight: 'el-icon-arrow-right',
        path: '/Solution',
        children: []
      }, ...data]
      return solution
    },
    // 处理生态伙伴自定义子项
    handleEcoPartner(data) {
      // data.push({ childrenList: [{ name: '天人厌氧子平台', path: '/AnSubPlatform?id=0', content: '项目设计-设备采购-财务税收-项目施工-原料收运-生产管控' }] })
      const ecoPartner = [{
        columnName: '生态伙伴',
        iconLeft: 'el-icon-menu',
        iconRight: 'el-icon-arrow-right',
        path: '/EcoPartner',
        children: []
      }, ...data]
      return ecoPartner
    },

    ...mapActions({
      quit: 'logout'
    }),
    handleSelect(index) {
      this.handleMenuClick(this.menuList[index], index)
    },
    handleMenuClick(item, index) { //页面跳转
      if (item.desc === 'appMarket') {
        this.curIndex = this.lastIndex
        window.open(`http://app.eiiplat.com/#/index?userName=${localStorage.userName}&token=${localStorage.usertoken}`)

      } else if (item.desc === 'openPlatform') {
        this.curIndex = this.lastIndex
        window.open(`http://open.eiiplat.com/`)
      } else if (this.$route.path != item.path) {
        this.curIndex = index
        this.lastIndex = index
        this.$router.push({ path: item.path })
      }
    },
    handleMenuEnter(item, index) {
      this.curIndex = index
      this.restaurants = this.loadAll(this.menuHeader[index].children);
      this.searchShow = item.name === '产品服务' || item.name === '解决方案'
      if (item.isDropdown) {
        this.visible = true
        this.active = 1
        this.list = this.menuList[index].children
      } else {
        this.visible = false
      }
    },
    handleMenuLeave(item) {
      if (!item.isDropdown) {
        this.visible = false
        this.curIndex = this.lastIndex
      }
    },
    handleDrawerLeaver() {
      this.visible = false
      this.searchVal = ''
      this.curIndex = this.lastIndex
    },
    handleClassClick(item, index) {
      if (index) {
        this.active = index
      } else {
        this.$router.push({ path: item.path })
      }
    },
    handleDetailsClick(item, index) {
      if (item.homepageDisplay !== '1') return

      let path = ''
      switch (this.menuList[this.curIndex].desc) {
        case 'productService':
          path = '/ProductDetails';
          break;
        case 'solution':
          path = '/SolutionDetails'
      }

      this.$router.push({ path: item.path || path, query: { id: item.id, index: this.curIndex } })
    },
    handleCommand(command) {
      if (command == 'console') {
        this.$router.push({ path: '/console' })
      } else if (command == 'reset') {
        this.$router.push({ path: '/resetPWD' })
      } else if (command == 'info') {
        //个人信息
        this.$router.push({ path: '/userInfo' })
      } else if (command == 'resetPhone') {
        //修改绑定手机
        this.$router.push({ path: '/resetPhoneNumber' })
      } else {
        this.$router.replace({ path: '/login' })
        this.quit()
      }
    }
    ,
    handleGoTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let everyValue = scrollTop / 10
      let i = 1

      // document.documentElement.scrollTop = document.body.scrollTop = 0
      let timer = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop = scrollTop - everyValue * i
        i++
        if (i > 10) {
          clearInterval(timer)
        }
      }, 30)
    }
    ,
    handleGoConsult() {
      fish.open()
      // window.open('http://qiyukf.com/script/044865c94981c048609d5c94c1ae9c6d.js', "ukefu-chat", "height=600, width=850, top=" + (window.screen.availHeight - 30 - 600) / 2 + ", left=" + (window.screen.availWidth - 10 - 750) / 2 + ",toolbar=no, menubar=no, scrollbars=no, resizable=no, directories=no,location=no, status=no")
    }
    ,
    handleGoMessage() {
      this.open = true
    }
    ,
    getCurIndex(to) {
      for (let i in this.menuList) {
        if (this.menuList[i].path == to.path) {
          this.curIndex = i
          this.lastIndex = i
          break
        } else if (i == to.query.index) {
          this.curIndex = i
          this.lastIndex = i
          break
        }
      }
    },
    cancle(data) {
      this.open = data
    }
    ,
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
    ,
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    }
    ,
    loadAll(data) {
      let loadList = this.handleData(data).map(item => {
        return {
          value: item.name,
          content: item.content,
          id: item.id,
          homepageDisplay: item.homepageDisplay
        }
      })

      return loadList
    }
    ,
    handleSelectTwo(item) {
      this.handleDetailsClick(item)
    }
    ,
    // 处理菜单数据铺平数组
    handleData(data) {
      return data.map(item => {
        return [...item.childrenList]
      }
      ).flat()
    }
  },

}
</script>

<style lang="scss">
.product-list {
  width: 100%;
  background: #ffffff;
  padding: 5px 15px;
  box-sizing: border-box;

  .box {
    height: 75px;
    background: #ffffff;
    border: 1px solid #e8ebf3;
    margin-top: 20px;
    cursor: pointer;
    padding: 10px;
    box-sizing: border-box;

    .title {
      font-size: 14px;
      font-weight: 400;
      height: 22px;
      margin-bottom: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .desc {
      font-size: 12px;
      font-weight: 400;
      color: rgba(19, 20, 21, 0.70);
      height: 17px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover .title {
      color: #e50009;
    }
  }
}

.popover-item {
  padding: 10px;
  cursor: pointer;

  .h1 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .h2 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.70)
  }

  .h3 {
    font-size: 12px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.70);
  }

  &:hover .h1 {
    color: #E50009;
  }

}

.head-container {
  width: 100%;
  height: 64px;
  line-height: 64px;
  background: #000;
  position: fixed;
  z-index: 1600;
  font-family: -apple-system-font, PingFang SC, Helvetica Neue, Helvetica, STHeiTi, sans-serif;

  .searchbox {
    width: 428px;
    height: 100%;
    background-color: #333;
    padding: 0 16px;

    .searchs {
      display: flex;
      justify-content: center;
      align-items: start;
      padding: 12px 0;
    }

    &.minisearch {
      // height: 320px;
      height: 150px;
      transition: all 1s;
    }

    .hotpot {
      width: 100%;
      height: 96px;
      // background-color: red;
      line-height: 20px;

      .title {
        color: #999;
        margin-bottom: 8px;
      }

      .potbox {
        margin: 0;
        padding: 0;

        ul {
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            display: inline-block;
            cursor: pointer;
            margin: 0;
            padding: 0;
            padding: 10px;
            background-color: #ccc;
            margin-right: 8px;
          }
        }
      }
    }
  }

  .search {
    background-color: #555 !important;

    .el-input__inner {
      background-color: #555;
    }

    .el-input__inner {
      border-right: none !important;
      color: #fff;

      &:focus {
        border: 1px solid #dcdfe6;
      }
    }

    .el-input-group__append {
      border-left: none;
    }

    .el-button {
      background-color: #555 !important;
      border: none;
      border-radius: 0px 4px 4px 0;
    }
  }

  .suspend-box {
    display: inline-block;
    position: fixed;
    right: 10px;
    bottom: 20%;

    .contact-btn {
      width: 46px;
      height: 148px;
      line-height: 20px;
      padding: 15px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #f3f4f6;
      border-radius: 50px;
      cursor: pointer;

      span {
        font-size: 14px;
        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC-Regular;
        color: rgba(19, 20, 21, 0.70);
      }

      i {
        color: #d7000f;
        font-size: 18px;
        margin-top: 5px;
      }
    }
  }

  .logo {
    width: 80px;
    margin-left: 0.2rem;
    vertical-align: middle;
    cursor: pointer;
  }

  .text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
    cursor: pointer;
  }

  .login {
    width: 28px;
    height: 20px;
    margin-right: 10px;
  }

  .login:hover {
    color: #d7000f;
  }

  .register {
    display: inline-block;
    width: 70px;
    height: 30px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    border-radius: 3px;
    background: #d7000f;
  }

  .drawer {
    width: 100%;
    height: 500px;
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 2000;
    box-sizing: border-box;
    // background: #fff;
    background: rgb(242, 246, 249);
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);

    .drawer-close {
      position: absolute;
      cursor: pointer;
      top: 20px;
      right: 20px;
    }

    .drawer-left:first-child {
      padding-top: 10px;
      box-sizing: border-box;
    }

    .drawer-left {
      display: inline-block;
      background: #F2F6F9;
      width: 20%;
      height: 1%;
      position: absolute;
      top: 58px;
      left: 0;
      font-size: 18px;
      font-weight: 400;

      .classification {
        display: flex;
        height: 10%;
        margin-bottom: 40px;
        flex-direction: column;
        align-items: flex-end;
        line-height: 0.35rem;
        cursor: pointer;

        div {
          display: inline-block;
          width: 50%;
          padding-left: 10px;
        }

        .active {
          color: #E50009;
          background: #fff;
        }
      }
    }

    .drawer-right::-webkit-scrollbar {
      display: none;
    }

    .drawer-right {
      display: inline-block;
      background: #FFF;
      width: 70%;
      height: 90%;
      position: absolute;
      top: 50px;
      left: 20%;
      overflow: auto;

      .details {
        width: 235px;
        margin-left: 20px;
        margin-top: 20px;
        display: inline-block;
        line-height: 16px;
        cursor: pointer;

        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 5px !important;
        }

        span {
          display: inline-block;
          vertical-align: top;
          line-height: 20px;
          ;
        }
      }

      .details:hover div {
        color: #fb4c58;
      }

      .details div {
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #131415;
        margin: 0;
      }

      .details span {
        font-size: 13px;
        font-weight: 400;
        word-wrap: break-word;
        color: rgba(19, 20, 21, 0.40);
      }
    }
  }

  .mask {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .serchBox {
    position: fixed;
    z-index: 2000;
    width: 100%;
    height: 30px;
    margin-top: -5px;
    left: 170px;
  }

  .el-autocomplete-suggestion li:hover {
    color: red;
  }

  .autocomplete-item__value {
    width: 100%;
    height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }

  .autocomplete-item__desc {
    width: 100%;
    height: 100%;
    font-size: 10px;
    color: rgba(19, 20, 21, 0.40);
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .console {
    margin-right: 30px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;

    &:hover {
      color: #e50009;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue